import fetch from '../utils/fetch'

//智能锁列表
export function getLockList(params) {
  return fetch({
    method:'GET',
    url:'smartlock/smartLockList',
    params
  })
}

//获取智能锁详情
export function getDetail(params) {
  return fetch({
    method:"GET",
    url:'smartlock/getDetail',
    params
  })
}


//获取使用人类型
export function getUserType() {
  return fetch({
    method:'GET',
    url:'smartlock/getUserType',
  })
}

//获取密码有效时间
export function pwdEffectiveTime(params) {
  return fetch({
    method:'GET',
    url:'smartlock/pwdEffectiveTime',
    params
  })
}

//发送智能锁密码
export function sendSmartLockPwd(params) {
  return fetch({
    method:'POST',
    url:'smartlock/sendSmartLockPwd',
    data:params
    })
}
//
export function getDynamicPwd(params) {
  return fetch({
    method:'GET',
    url:'smartlock/getDynamicPwd',
    params
  })
}
